import { render, staticRenderFns } from "./Filesmanager.vue?vue&type=template&id=accaafe2"
import script from "./Filesmanager.vue?vue&type=script&lang=js"
export * from "./Filesmanager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports